import UIDs from "../../../../UIDs";

const uid = UIDs.screens.homework.article;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    UPDATE_SETTINGS: `${uid}.updateSettings`,
};

export { ActionTypes };